import React from "react";
export const SimpleIconAndTextCard = ({ iconUrl, title, text, iconAltText }) => React.createElement("div", { className: "simple-icon-and-text-card" },
    React.createElement("img", { src: iconUrl, alt: iconAltText || "" }),
    React.createElement("h6", { className: "h6-v2dot6 simple-icon-and-text-card__title" }, title),
    text && React.createElement("div", { className: "simple-icon-and-text-card__text" }, text));
